<template>
  <template v-if="settlementDetails">
    <div v-if="processedPayments.length > 0" class="rounded-lg border border-gray-200 overflow-hidden bg-white">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-900">Transactions</h2>
      </div>
      <div class="border-t border-gray-200">
        <table class="w-full table-auto text-sm text-left">
          <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
            <tr>
              <th class="px-4 py-2">Transaction ID</th>
              <th class="px-4 py-2">Date</th>
              <th class="px-4 py-2">Customer</th>
              <th class="px-4 py-2">Order Ref</th>
              <th class="px-4 py-2">Method</th>
              <th class="px-4 py-2">Provider</th>
              <th class="px-4 py-2">Transaction Type</th>
              <th class="px-4 py-2 text-right">Fees - Incl VAT</th>
              <th class="px-4 py-2 text-right">Amount</th>
            </tr>
          </thead>
          <tbody class="text-grey-light-600">
            <tr v-for="payment in processedPayments" :key="payment.payment._id" class="border-b border-gray-200">
              <td class="p-5">
                <CopyableText :text="payment.payment._id" />
              </td>
              <td class="p-5">{{ dayjs(payment.payment.verifiedAt).format('DD-MM-YYYY') }}</td>
              <td class="p-5">{{ payment.benefactor.name || 'Anonymous' }}</td>
              <td class="p-5">{{ payment.reference }}</td>
              <td class="p-5">{{ payment.paymentMethod }}</td>
              <td class="p-5">{{ payment.paymentProvider }}</td>
              <td class="p-5">{{ payment.payment.paymentType }}</td>
              <td class="p-5 text-right">{{ displayCurrency(payment.amountTotal) }}</td>
              <td class="p-5 text-right">{{ displayCurrency(payment.payment.amount) }}</td>
            </tr>
            <tr>
              <td class="p-5 text-gray-900 font-semibold" colspan="8">Total Amount</td>
              <td class="p-5 text-gray-900 font-semibold text-right">
                {{ displayCurrency(settlementDetails.feesPerPaymentOnlineSettlementAmount) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="offlinePayments.length > 0" class="rounded-lg border border-gray-200 overflow-hidden bg-white mt-6">
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-900">Offline / Direct / Transfers Transactions</h2>
      </div>
      <div class="border-t border-gray-200">
        <table class="w-full table-auto text-sm text-left">
          <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
            <tr>
              <th class="px-4 py-2">Transaction ID</th>
              <th class="px-4 py-2">Date</th>
              <th class="px-4 py-2">Customer</th>
              <th class="px-4 py-2">Order Ref</th>
              <th class="px-4 py-2">Method</th>
              <th class="px-4 py-2">Provider</th>
              <th class="px-4 py-2">Transaction Type</th>
              <th class="px-4 py-2">Fees - Incl VAT</th>
              <th class="px-4 py-2">Amount</th>
            </tr>
          </thead>
          <tbody class="text-grey-light-600">
            <tr v-for="payment in offlinePayments" :key="payment.payment._id" class="border-b border-gray-200">
              <td class="p-5">
                <CopyableText :text="payment.payment._id" />
              </td>
              <td class="p-5">{{ dayjs(payment.payment.verifiedAt).format('DD-MM-YYYY') }}</td>
              <td class="p-5">{{ payment.benefactor.name || 'Anonymous' }}</td>
              <td class="p-5">{{ payment.reference }}</td>
              <td class="p-5">{{ payment.paymentMethod }}</td>
              <td class="p-5">{{ payment.paymentProvider }}</td>
              <td class="p-5">{{ payment.payment.paymentType }}</td>
              <td class="p-5">{{ displayCurrency(payment.amountTotal) }}</td>
              <td class="p-5">{{ displayCurrency(payment.payment.amount) }}</td>
            </tr>
            <tr>
              <td class="p-5 text-gray-900 font-semibold" colspan="8">Total Amount</td>
              <td class="p-5 text-gray-900 font-semibold">
                {{ displayCurrency(settlementDetails.feesPerPaymentOfflineAmount) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import CopyableText from '@/components/common/CopyableText.vue';
import type { Settlement } from '@/models/settlements';
import { displayCurrency } from '@/utils/format.utils';
import dayjs from 'dayjs';
import { computed } from 'vue';

const props = defineProps<{
  settlementDetails: Settlement | undefined;
}>();

const processedPayments = computed(() => {
  if (props.settlementDetails?.feesPerPayment && props.settlementDetails?.feesPerPayment.length > 0) {
    const payments = props.settlementDetails?.feesPerPayment.filter(
      (p: any) => p.paymentProvider !== 'NONE' && p.paymentProvider !== 'SYSTEM',
    );
    return payments;
  }
  return [];
});

const offlinePayments = computed(() => {
  if (props.settlementDetails?.feesPerPayment && props.settlementDetails?.feesPerPayment.length > 0) {
    const payments = props.settlementDetails?.feesPerPayment.filter(
      (p: any) => p.paymentProvider === 'NONE' || p.paymentProvider === 'SYSTEM',
    );
    return payments;
  }
  return [];
});
</script>
